import React from 'react'
import { Query } from 'react-apollo'
import Select from 'react-select'
import zone from 'graphql/queries/zone'

const ZoneField = ({ input: { onChange, value }}) => {
  return (
    <Query query={zone} fetchPolicy="cache-and-network">
      {({ loading, error, data }) => {
        if (loading) return <p>Caricamento zone...</p>
        if (error) return <p>Errore :(</p>

        return (
          <Select
            multi={true}
            options={data.allZone.map(zona => ({
              value: zona.nome,
              label: zona.nome,
            }))}
            value={value}
            //simpleValue={true}
            onChange={onChange}
            placeholder="Seleziona"
            noResultsText="Nessun risultato"
            //promptTextCreator={label => `Crea nuovo tag "${label}"`}
          />
        )
      }}
    </Query>
  )
}

export default ZoneField



// WEBPACK FOOTER //
// ./src/views/App/Clienti/ZoneField.jsx